import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;
Vue.material.locale.dateFormat = 'MM/dd/yyyy';

new Vue({
  render: h => h(App),
}).$mount('#app')
